import { FormWithRedux } from '../../FormWithRedux';

export class ACCMRIInformationForm extends FormWithRedux {

    constructor() {
        super('PathwayInformationForm');
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/accmri01/IntroForm/ACCMRI-InformationForm.js